import { Stack, LinearProgress } from '@mui/material';
import { Suspense, useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { NetworkErrorBoundary } from 'rest-hooks';
import { ColumnResizerProvider } from './columnResizer/columnResizer';
import { TestRunner } from '../evaluateRunner/evaluateRunner';
import HeaderBar from './headerBar';
import NavBar from './navbar';
import useWindowDimensions from './windowDimension';

export const Layout = () => {
  const componentRef = useRef<HTMLInputElement>(null);
  const [componentHeight, setComponentHeight] = useState('');
  const { height } = useWindowDimensions();

  useEffect(() => {
    if (componentRef.current) {
      const { top } = componentRef.current.getBoundingClientRect();
      const componentHeight = height - top - 50;
      setComponentHeight(componentHeight + 'px');
    }
  }, []);

  return (
    <Stack ref={componentRef} direction={'row'} sx={{ height: '100vh', width: '100vw' }}>
      <NavBar />
      <Stack direction={'column'} flexGrow={1} sx={{ overflow: 'hidden' }}>
        <HeaderBar />
        <main style={{ height: componentHeight, display: 'flex', flexGrow: 1 }}>
            <ColumnResizerProvider>
              <Suspense fallback={<LinearProgress />}>
                <NetworkErrorBoundary fallbackComponent={() => <p>Error</p>}>
                  <Outlet />
                </NetworkErrorBoundary>
              </Suspense>
              <TestRunner />
            </ColumnResizerProvider>
        </main>
      </Stack>
    </Stack>
  );
};